export const refereeToFormTransformer = referee => {
    if (!referee) {
        return null;
    }
    return {
        ...referee,
        qualification: referee.qualification ? referee.qualification.id : null,
    };
}
